<script setup>
import { computed } from 'vue';

import ContributorsTable from '~/common/components/ContributorsTable.vue';

const props = defineProps({
  contributors: {
    type: Array,
    required: true,
  },
  fromDate: {
    type: String,
    default: '',
  },
  toDate: {
    type: String,
    default: '',
  },
});

const filterData = computed(() => ({
  fromDate: props.fromDate,
  toDate: props.toDate,
}));
</script>

<template>
  <ContributorsTable
    :contributors="contributors"
    :filter-data="filterData"
  />
</template>
